import * as React from 'react'

import { Dialog as DialogPrimitive } from '@base-ui/react/dialog'

import {
  Dialog,
  DialogContent,
} from '~/client/src/shared/components/shadcn-ui/dialog'

// Figma 12507:87721.

const DEFAULT_MODAL_WIDTH_PX = 512

interface IProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  children: React.ReactNode
  /** In-tree mount point so nested dialogs portal inside Radix's focus trap. */
  nestedDialogPortalRef?: React.RefObject<HTMLDivElement | null>
  widthPx?: number
}

export const ModalSurface: React.FC<IProps> = ({
  open,
  onOpenChange,
  children,
  nestedDialogPortalRef,
  widthPx = DEFAULT_MODAL_WIDTH_PX,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent
      // Fixed 85vh — the inner list is the scroll surface; modal never resizes to content
      // (prevents "jumps smaller" on empty/collapsed states).
      className="tw:flex tw:h-[85vh] tw:flex-col tw:gap-0 tw:overflow-hidden tw:rounded-lg tw:p-0 tw:sm:max-w-none"
      style={{ width: widthPx, maxWidth: `calc(100vw - 2rem)` }}
      showCloseButton={false}
    >
      <DialogPrimitive.Title className="tw:sr-only">
        Map Views Manager
      </DialogPrimitive.Title>
      <DialogPrimitive.Description className="tw:sr-only">
        Browse and manage map views for the project.
      </DialogPrimitive.Description>
      {children}
      <div ref={nestedDialogPortalRef} />
    </DialogContent>
  </Dialog>
)
